import {
  entitySettingsFailure,
  entitySettingsRequest,
  entitySettingsSuccess,
} from 'store/reducers/entitySettings';
import {
  createProviderFailure,
  createProviderRequest,
  createProviderSuccess,
  loadProviderFailure,
  loadProviderRequest,
  loadProviderSuccess,
} from 'store/reducers/provider';

import { fetchData } from './fetchData';

export const loadProvider = (puid, actions) => (dispatch, getState) => {
  const providerId = puid || getState().provider.uuid;
  return fetchData({
    endpoint: `provider/${providerId}`,
    actions: actions || [
      loadProviderRequest,
      loadProviderSuccess,
      loadProviderFailure,
    ],
  })(dispatch, getState);
};

export const createProvider = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'provider',
    actions: [
      createProviderRequest,
      createProviderSuccess,
      createProviderFailure,
    ],
    httpMethod: 'post',
    body,
    showAPIerror: true,
  })(dispatch, getState);

export const editProvider = (body) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  return fetchData({
    endpoint: `provider/${providerId}`,
    actions: [
      createProviderRequest,
      createProviderSuccess,
      createProviderFailure,
    ],
    httpMethod: 'patch',
    body,
  })(dispatch, getState);
};

export const editLocation = (body) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  const locationId = getState().provider.locations[0].uuid;
  return fetchData({
    endpoint: `provider/${providerId}/location/${locationId}`,
    actions: [
      createProviderRequest,
      createProviderSuccess,
      createProviderFailure,
    ],
    httpMethod: 'patch',
    body,
  })(dispatch, getState);
};

export const createLocation = (body, puid) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  return fetchData({
    endpoint: `provider/${puid || providerId}/location`,
    actions: [null, null, null],
    httpMethod: 'post',
    body,
  })(dispatch, getState);
};

export const loadLocation =
  ({ animalTypeId, animalBreedId, animalSizeId }) =>
  (dispatch, getState) => {
    const { provider } = getState();
    const luid = provider.locations?.[0]?.uuid;
    const typeQuery = animalTypeId ? `&animal_type_id=${animalTypeId}` : '';
    const breedQuery = animalBreedId ? `&breed_id=${animalBreedId}` : '';
    const sizeQuery = animalSizeId ? `&size_id=${animalSizeId}` : '';
    const query = `${typeQuery}${breedQuery}${sizeQuery}`;

    return fetchData({
      endpoint: `provider/location/${luid}?${query}`,
      actions: [null, null, null],
    })(dispatch, getState);
  };

export const addService = (body) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  const locationId = getState().provider.locations[0].uuid;
  return fetchData({
    endpoint: `provider/${providerId}/location/${locationId}/service`,
    actions: [null, null, null],
    httpMethod: 'post',
    body,
  })(dispatch, getState);
};

export const editService = (body, serviceId) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  const locationId = getState().provider.locations[0].uuid;
  return fetchData({
    endpoint: `provider/${providerId}/location/${locationId}/service/${serviceId}`,
    actions: [null, null, null],
    httpMethod: 'patch',
    body,
  })(dispatch, getState);
};

export const deleteService = (serviceId) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  const locationId = getState().provider.locations[0].uuid;
  return fetchData({
    endpoint: `provider/${providerId}/location/${locationId}/service/${serviceId}`,
    actions: [null, null, null],
    httpMethod: 'delete',
  })(dispatch, getState);
};

export const uploadProviderAvatar = (body) => (dispatch, getState) => {
  const providerId = getState().provider.uuid;
  const locationId = getState().provider.locations[0].uuid;
  return fetchData({
    endpoint: `provider/${providerId}/location/${locationId}/image/upload/logo`,
    actions: [null, null, null],
    httpMethod: 'post',
    isMedia: true,
    body,
  })(dispatch, getState);
};

export const getLocationSettings = () => (dispatch, getState) => {
  const { locations } = getState().provider;
  const luid = locations[0]?.uuid;
  return fetchData({
    endpoint: `location/${luid}/settings`,
    actions: [
      entitySettingsRequest,
      entitySettingsSuccess,
      entitySettingsFailure,
    ],
  })(dispatch, getState);
};
